export default __webpack_public_path__ + "static/media/thumbnail.28b5ba68.webp";